module.exports = (__webpack_public_path__ || '') + "static/images/apple-touch-icon-72x72-29f6fe50adffeb0794728ebbea6dbd92.png";